import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@shared/utils';
import type { AccountResponse } from '@shared/api';
import { Text } from '@shared/widgets';

interface AccountDetailsProps {
  className?: string;
  account: AccountResponse;
  withStatus?: boolean;
}

export const AccountDetails = (props: AccountDetailsProps) => {
  const { t } = useTranslation('accounts');

  const accountDetails = useMemo(
    () =>
      [
        { label: t('payment.tile.fields.iban'), value: props.account.iban },
        { label: t('payment.tile.fields.accountNumber'), value: props.account.accountNumber },
        props.withStatus && {
          label: t('payment.tile.fields.accountStatus'),
          value: t(`statuses.account.${props.account.status}`, { ns: 'common' }),
        },
      ].filter(Boolean) as { label: string; value: string | null }[],
    [t, props.account],
  );
  return (
    <ul className={cn(props.className)}>
      {accountDetails.map((item, index) => (
        <li key={index}>
          <Text size='xs'>{item.label}</Text>
          <Text weight='semibold' size='xs'>
            {item.value}
          </Text>
        </li>
      ))}
    </ul>
  );
};
